// Packages Actions

import { HOWL_N_LEARN_CODE, LATE_CHECKOUT_PREFIXES } from '../../../utilities/constants';
import { getKidsUnderAge } from '../../../utilities/guestsUtils';
import packagesActionTypes from './packages.types';

const getAdjustmentPackage = selectedPackage => {
  if (selectedPackage.adjustmentCode && selectedPackage.adjustmentCode.length > 0) {
    return {
      packageCode: selectedPackage.adjustmentCode[0],
      quantity: selectedPackage.quantity,
      isAdjustment: true,
      parentPackageCode: selectedPackage.packageCode,
      packageType: selectedPackage.packageType
    };
  }
  return null;
};

function upsertToPackagesArray(packagesArray, obj) {
  let result = [...packagesArray];
  const index = result.findIndex(e => matchByPackageCode(e, obj));
  if (index === -1) {
    result.push(obj);
  } else {
    result[index] = obj;
  }
  return result;
}

function removeFromPackagesArray(packagesArray, obj) {
  return packagesArray.filter(pkg => {
    if (obj.isExtra) {
      return pkg.packageCode !== obj.packageCode || (pkg.packageCode === obj.packageCode && !pkg.isExtra);
    } else {
      return pkg.packageCode !== obj.packageCode;
    }
  });
}

function matchByPackageCode(e, params) {
  if (params.isExtra) {
    return e.packageCode === params.packageCode && e.isExtra;
  } else {
    return e.packageCode === params.packageCode && !e.isExtra;
  }
}

/**
 * when non billable kid is added, check if selected package contains adjustment code, if available add the adjustment package to selected package list.
 */

export const upsertPackage = (params, isCartVariation) => (dispatch, getState) => {
  const state = getState();
  let currentPackages = state.packages.selectedPackages;
  const kidsAgesList = state.guests.kidsAges;
  const nonBillableChildren = getKidsUnderAge(kidsAgesList, 4);

  let selectedPackages = upsertToPackagesArray(currentPackages, params);
  if (nonBillableChildren > 0) {
    const adjustmentPackage = getAdjustmentPackage(params);
    if (adjustmentPackage) {
      selectedPackages = upsertToPackagesArray(selectedPackages, adjustmentPackage);
    }
  }
  const learnPackage = selectedPackages.find(pckg => pckg.packageCode === HOWL_N_LEARN_CODE);
  if (learnPackage) {
    const lcoPackage = selectedPackages.find(selectedPackages =>
      selectedPackages.packageCode.includes(LATE_CHECKOUT_PREFIXES.code)
    );
    if (lcoPackage) {
      selectedPackages = removeFromPackagesArray(selectedPackages, lcoPackage);
    }
  }
  dispatch({
    type: packagesActionTypes.UPSERT_PACKAGES,
    selectedPackages: selectedPackages,
    isCartVariation
  });
};
export const deletePackage = params => (dispatch, getState) => {
  let currentPackages = [...getState().packages.selectedPackages];
  const adjustmentPackages = currentPackages.filter(
    pkg => (pkg.parentPackageCode || pkg.packageCode) === params.packageCode && pkg.isAdjustment
  );

  if (adjustmentPackages.length > 0) {
    currentPackages = removeFromPackagesArray(currentPackages, adjustmentPackages[0]);
  }
  const remainingPackages = removeFromPackagesArray(currentPackages, params);
  dispatch({
    type: packagesActionTypes.DELETE_PACKAGES,
    selectedPackages: remainingPackages
  });
};

export const clearSelectedPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.SET_SELECTED_PACKAGES,
    selectedPackages: []
  });
};

export const clearPackagesByCodes = packagesCodes => (dispatch, getState) => {
  const currentPackages = getState().packages.selectedPackages;
  const selectedPackages = currentPackages.filter(
    selectedPackage => !packagesCodes.includes(selectedPackage.packageCode)
  );
  dispatch({
    type: packagesActionTypes.SET_SELECTED_PACKAGES,
    selectedPackages
  });
};
export const clearPlanPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.CLEAR_PACKAGES_PLAN
  });
};
export const packagesImpressions = eventProps => dispatch => {
  dispatch({
    type: packagesActionTypes.GTM_PACKAGES_IMPRESSIONS,
    eventProps
  });
};
